module.exports = __webpack_public_path__ + "fad415a5116d04db53726f8e94bb26ba.jpg";